import '@popperjs/core';
import 'bootstrap/js/dist/dom/selector-engine';
import 'bootstrap/js/dist/collapse';

const buttons = document.querySelectorAll('.accordion-button');

buttons.forEach(function (button) {
  button.addEventListener('click', function () {
    console.log(jQuery(this));
    if (jQuery(this).hasClass('collapsed')) {
      jQuery(this).find('.accordion-header__collapse').show();
      jQuery(this).find('.accordion-header__expand').hide();
    } else {
      jQuery(this).find('.accordion-header__collapse').hide();
      jQuery(this).find('.accordion-header__expand').show();
    }
  });
});

/* const button1 = document.querySelector('.accordion-button');
console.log(button1);
button1.addEventListener('click', function () {
  console.log(jQuery(this));
  if (jQuery(this).hasClass('collapsed')) {
    jQuery(this).find('.accordion-header__collapse').show();
    jQuery(this).find('.accordion-header__expand').hide();
  } else {
    jQuery(this).find('.accordion-header__collapse').hide();
    jQuery(this).find('.accordion-header__expand').show();
  }
}); */
